var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8.925a5.425 5.425 0 1 1 10.85 0 5.425 5.425 0 0 1-10.85 0ZM8.925 2.5a6.425 6.425 0 1 0 4.579 10.932c.024.07.064.136.12.191l2.644 2.645a.5.5 0 0 0 .707-.707l-2.645-2.645a.499.499 0 0 0-.263-.138A6.425 6.425 0 0 0 8.925 2.5Z",
    fill: "#818C96"
  })));
};

export default SvgSearch;